import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { regexList } from '@app/core/helpers/constants';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-single-parameter-input',
  templateUrl: './single-parameter-input.component.html',
  styleUrls: ['./single-parameter-input.component.scss']
})
export class SingleParameterInputComponent implements OnInit {
  @Input() configurationData: { systemName: string; label: string; value: string };
  @Output() emitValue: EventEmitter<{ value: string; systemName: string; hasErrors: boolean }> = new EventEmitter();

  public textForm: UntypedFormGroup;

  private destroy$ = new Subject<void>();

  get configForm(): any {
    return this.textForm.controls;
  }

  constructor(private readonly fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.textForm = this.fb.group({
      text: ['', this.getTextValidator()]
    });

    this.textForm.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.emit()),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  private getTextValidator(): any {
    if (this.configurationData?.systemName === 'player_id') {
      return [Validators.pattern(regexList[7].regex)];
    } else {
      return [];
    }
  }

  private emit(): void {
    if (!this.configForm.text.invalid) {
      this.emitValue.emit({
        value: this.configForm.text.value,
        systemName: this.configurationData.systemName,
        hasErrors: this.configForm.text.invalid
      });
    }
  }
}
